module.exports = __webpack_public_path__ + "img/Pag3.27fe2384.png";